import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { renderWebsiteAreaContent } from '@utils/WebsiteAreaContent';
import { formatStringToDisplayCase } from 'pubweb-smokey/dist/utils/formatters';
import { getSiteUrl } from '@utils/config';
import AreaHeader from '../Shared/AreaHeader/AreaHeader';
import LocationsCityListingAccordion from './LocationsCityListingAccordion';
import { LocationsStateListingStyles } from './LocationsStateListing.styled';
import { CTAModifiedBGStyles } from '../Shared/CTA/CTAModifiedBG.styled';

const LocationsStateListing = ({
  websiteAreaContent,
  locationsListByState,
  fullStateName,
}) => {
  const router = useRouter();

  locationsListByState[0]?.cities?.sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name)
  );

  const recordSelectedAccordion = (cityAccordionName) => {
    //This keeps track of the user's scroll position in case they go to a dealer page and then hit back
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // const scrollPosition = window.scrollY;
      // localStorage.setItem("LocationStatesPageScrollPosition", scrollPosition);
      localStorage.setItem('LocationAccordionToOpen', cityAccordionName);
      localStorage.setItem('LocationStateName', fullStateName);
    }
  };

  let [activeCityAccordion, setActiveCityAccordion] = useState(
    locationsListByState[0]?.cities[0]?.name
  );

  useEffect(() => {
    // if a user is coming to this page after viewing a DLP and hitting back, open the last accordion they were looking at
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      if (localStorage.getItem('LocationAccordionToOpen')) {
        if (localStorage.getItem('LocationStateName') === fullStateName) {
          setActiveCityAccordion(
            localStorage.getItem('LocationAccordionToOpen')
          );
          //if a scroll position for this page is found in local storage scroll to there (see recordSelectedAccordion function)
          // window.scrollTo(0, localStorage.getItem("LocationStatesPageScrollPosition"));
        }
      } else {
        // eslint-disable-line no-empty
      }
    } else {
      setActiveCityAccordion(locationsListByState[0]?.cities[0]?.name);
    }
  }, [locationsListByState]);

  useEffect(() => {
    recordSelectedAccordion(activeCityAccordion);
  }, [activeCityAccordion]);

  let renderedAreaContent = renderWebsiteAreaContent(websiteAreaContent);
  let heroHeader =
    '25 Locations in ' + fullStateName &&
    formatStringToDisplayCase(fullStateName);
  let heroText =
    websiteAreaContent && websiteAreaContent.areaHeaderText !== null
      ? websiteAreaContent.areaHeaderText
      : `Shop homes at Clayton and independent retail locations near you. Browse [state] store locations below where you can learn about purchasing and owning a new mobile, modular, manufactured home with help from a knowledgeable home consultant.`;

  heroText = heroText.replace(
    '[state]',
    fullStateName && formatStringToDisplayCase(fullStateName)
  );

  return (
    <>
      <Head htmlAttributes={{ lang: 'en' }}>
        <title>
          {fullStateName && formatStringToDisplayCase(fullStateName)}{' '}
          Manufactured Homes | Clayton Homes
        </title>
        <meta
          name="description"
          content={`Locate your nearest ${
            fullStateName && formatStringToDisplayCase(fullStateName)
          } Clayton home center where you can tour homes and view floor plans of our mobile, modular and manufactured homes.`}
        />
        <link rel="canonical" href={`${getSiteUrl(router.pathname)}`} />
        <meta
          property="og:image"
          content={`${getSiteUrl('/public-assets/images/clayton-logo.jpg')}`}
        />
      </Head>

      <AreaHeader
        headerText={heroHeader + ' Manufactured Homes for Sale'}
        infoText={heroText}
        breadCrumbs={[
          {
            link: '/locations/',
            text: 'Locations',
          },
          {
            text: formatStringToDisplayCase(fullStateName),
          },
        ]}
      />

      <LocationsStateListingStyles>
        {locationsListByState?.[0]?.cities ? (
          <div className="locations-state-listing-inside">
            {locationsListByState?.[0]?.cities
              //alphebetize city cards
              .sort((a, b) => a.name.toLowerCase().localeCompare(b.name))
              .map((location, i) => {
                return (
                  <LocationsCityListingAccordion
                    key={i}
                    city={location.name.toLowerCase()}
                    storesByCity={location.dealers}
                    isOpen={activeCityAccordion === location.name}
                    onHeaderClick={() => {
                      activeCityAccordion === location.name
                        ? setActiveCityAccordion(null)
                        : setActiveCityAccordion(location.name);
                    }}
                  />
                );
              })}
          </div>
        ) : (
          <div className="locations-state-listing-inside no-home-centers">
            <p>
              No home centers found in{' '}
              {fullStateName && formatStringToDisplayCase(fullStateName)}.
            </p>
          </div>
        )}

        <div className="cta-container">
          <CTAModifiedBGStyles>
            {renderedAreaContent.areaCtas !== null
              ? renderedAreaContent.areaCtas.map((cta) => {
                  return cta;
                })
              : null}
          </CTAModifiedBGStyles>
        </div>
      </LocationsStateListingStyles>
    </>
  );
};

LocationsStateListing.propTypes = {
  fullStateName: PropTypes.string,
  locationsListByState: PropTypes.any,
  websiteAreaContent: PropTypes.shape({
    areaHeaderText: PropTypes.any,
  }),
};

export default LocationsStateListing;
